import React, { memo } from 'react';

const formatDate = (dateTime) => {
  if (!dateTime) return "N/A";
  const now = new Date();
  const diff = now - new Date(dateTime);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days > 365) return `${Math.floor(days / 365)}y`;
  if (days > 30) return `${Math.floor(days / 30)}mo`;
  if (days > 0) return `${days}d`;
  if (diff > 3600000) return `${Math.floor(diff / 3600000)}h`;
  return `${Math.floor(diff / 60000)}m`;
};

const StatItem = ({ icon, value, label }) => (
  <div className="stat-item">
    <span className="stat-icon">{icon}</span>
    <span className="stat-value">{value}</span>
    <span className="stat-label">{label}</span>
  </div>
);

export const VenueCard = memo(({ venue, onEdit, onView, onShare }) => {
  const images = venue.images || [];
  const primaryImage = images.find(img => img.isPrimary) || images[0];
  const category = venue.category || { id: 0, name: 'Unknown' };
  const subcategory = venue.subcategory || { id: 0, name: 'Unknown' };
  const venueSections = venue.sections || [];
  const rules = venue.rules || [];
  const createdAt = venue.createdAt;

  const handleShare = () => {
    if (venue.address) {
      navigator.clipboard?.writeText?.(venue.address);
      alert("Address copied to clipboard!");
    }
    onShare?.(venue);
  };

  return (
    <div className="venue-card">
      <div className="venue-card-image">
        {primaryImage?.url ? (
          <img src={primaryImage.url} alt={venue.name || 'Venue'} />
        ) : (
          <div className="image-placeholder-large">📷</div>
        )}
        <div className={`status-badge ${venue.isActive ? 'active' : 'inactive'}`}>
          <span>{venue.isActive ? '✓' : '✗'}</span>
          <span>{venue.isActive ? 'Active' : 'Inactive'}</span>
        </div>
        <div className="image-overlay" />
        <div className="venue-name-overlay">{venue.name || 'Unnamed Venue'}</div>
      </div>
      <div className="venue-card-content">
        <div className="category-chips">
          <span className="category-chip blue">{category.name}</span>
          <span className="category-chip purple">{subcategory.name}</span>
        </div>
        <div className="venue-location">
          <span className="location-icon-small">📍</span>
          <span className="location-text">{venue.address || 'No address'}</span>
        </div>
        {venueSections.length > 0 && (
          <div className="sections-preview">
            <div className="preview-label">Available Spaces</div>
            <div className="preview-list">
              {venueSections.slice(0, 3).map((section, idx) => (
                <div key={idx} className="preview-item">
                  <div className="preview-name">{section.name || 'Unnamed'}</div>
                  <div className="preview-details">
                    <span>📐 {section.areaSqft || 0} sqft</span>
                    <span>👥 {section.minCapacity || 0}-{section.maxCapacity || 0}</span>
                  </div>
                  <div className="preview-price">
                    <span>₹{section.offeredPrice || section.pricePerHour || 0}/hr</span>
                    {section.offeredPrice && <span className="original-price">₹{section.pricePerHour}</span>}
                  </div>
                </div>
              ))}
            </div>
            {venueSections.length > 3 && (
              <div className="more-spaces">+{venueSections.length - 3} more spaces</div>
            )}
          </div>
        )}
        <div className="stats-row">
          <StatItem icon="📷" value={images.length} label="Images" />
          <StatItem icon="🏢" value={venueSections.length} label="Spaces" />
          <StatItem icon="📋" value={rules.length} label="Rules" />
          <StatItem icon="📅" value={formatDate(createdAt)} label="Created" />
        </div>
        <div className="action-buttons">
          <button className="action-edit" onClick={() => onEdit(venue)}>Edit</button>
          <button className="action-view" onClick={() => onView(venue)}>View</button>
          <button className="action-share" onClick={handleShare}>Share</button>
        </div>
      </div>
    </div>
  );
});

VenueCard.displayName = 'VenueCard';